import { FormEvent, useLayoutEffect, useState } from "react";
import styled from "styled-components";

import { SubProductAction } from "features/product/types/actions.subproduct";
import SubmitButton from "features/shared/components/form/components/submitButton";
import ModalHeader from "features/shared/components/modals/modalHeader";
import Modal from "features/shared/components/modal";

import { useDispatch } from "services/redux/rootReducer";
import { MultilingualString } from "features/shared/types/string";
import BasicInput from "features/shared/components/form/components/basicInput";
import LabelWrapper from "features/shared/components/form/components/labelWrapper";
import useCurrentTableState from "../hooks/useCurrentTableState";

interface Props {
    onCloseHandler: () => void;
}

const NameEditModal: React.FC<Props> = ({ onCloseHandler }) => {
    const dispatch = useDispatch();
    const { name } = useCurrentTableState();

    const [rawName, setRawName] = useState<MultilingualString>({
        en: "",
        th: "",
    });

    useLayoutEffect(() => {
        setRawName(name);
    }, [name]);

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (!rawName.en || !rawName.th) {
            return alert(
                "Are you sure you want to exit? At least one name is empty"
            );
        }

        dispatch({
            type: SubProductAction.SET_TABLE_NAME,
            name: rawName,
        });

        onCloseHandler();
    };
    return (
        <Modal id="subProductNameEdit" onCloseHandler={onCloseHandler}>
            <ModalContainer>
                <ModalHeader
                    onCloseHandler={onCloseHandler}
                    headingText="Change Table Name"
                />
                <Container>
                    <FormContainer onSubmit={handleSubmit}>
                        <LabelWrapper label="Name (EN)">
                            <BasicInput
                                name="en"
                                value={rawName.en}
                                onChangeHandler={(e) =>
                                    setRawName((rawName) => ({
                                        ...rawName,
                                        en: e.target.value,
                                    }))
                                }
                            />
                        </LabelWrapper>
                        <LabelWrapper label="Name (TH)">
                            <BasicInput
                                name="th"
                                value={rawName.th}
                                onChangeHandler={(e) =>
                                    setRawName((rawName) => ({
                                        ...rawName,
                                        th: e.target.value,
                                    }))
                                }
                            />
                        </LabelWrapper>
                        <SubmitButton text="Set Name" />
                    </FormContainer>
                </Container>
            </ModalContainer>
        </Modal>
    );
};

const ModalContainer = styled.div`
    background: ${(props) => props.theme.colors.neutral[100]};
    color: ${(props) => props.theme.colors.neutral[800]};
    height: fit-content;
    width: 50vw;

    border-radius: 0.2rem;

    resize: both;

    display: flex;
    flex-flow: column;

    & > *:first-child {
        flex: 0 0 4rem;
    }

    & > *:nth-child(2) {
        flex: 1;
    }

    @media (max-width: 768px) {
        height: 70vh;
        width: 95vw;
    }
`;

const Container = styled.div`
    display: flex;
    flex-flow: column;
    padding: 5%;
`;

const FormContainer = styled.form`
    display: contents;
    & > * {
        &:first-child {
            flex: 1;
            z-index: 2;
        }
        &:nth-child(2) {
            min-width: 2.3rem;
            flex: 0 0 2.3rem;
            margin-top: 1rem;
        }
    }
`;

export default NameEditModal;
